import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import useAuth from "../hooks/useAuth";
import { useLocalStorage } from "../hooks/useLocalStorage";
import { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';


/**
 * ici sont déclarés les items du menus de l'app
 * On peut en rajouter, il seront automatiquement ajouté au menu de l'app
 * Les routes seront crées dynamiquement par rapports à ces éléments dans l'index.js
 * 
 * !!! ATTENTION !!! j'ai fait en sorte que les components aient le même nom que l'url en majuscule, pour que ca soit plus pratique
 * Si jamais, on peut imaginer rajouter ue propriété "component" pour chaque élement, avec le nom du component (ex : <Coordonnees />)
 * L'import est dynamique, toujours mettre les composants du menu dans le dossier pages/
 * Je n'ai pas trouvé de solution pour importer dynamiquement les composants de /pages, il faudra les ajouter manuellement dans le fichier index.js de la racine, pas le choix. 
 */

export const menu_items = [
    {
        url: 'coordonnees',
        name: 'Mes informations',
        icon: 'fa-user',
        children: ['edit']
        // component: Coordonnees,
    }, {
        url: 'contrat',
        name: 'Mon contrat',
        // icon: 'faFileContract',
        icon: 'fa-file-contract'
    }, {
        url: 'factures',
        name: 'Mes factures',
        // icon: 'faFileInvoiceDollar',
        icon: 'fa-file-invoice-dollar',
    }, {
        url: 'paiements',
        name: 'Mes paiements',
        // icon: 'faHandHoldingDollar',
        icon: 'fa-regular fa-credit-card',
    }, {
        url: 'suivi',
        name: 'Mon suivi',
        // icon: 'fa-bars-progress',
        icon: 'fa-solid fa-desktop',
    }, {
        url: 'tickets',
        name: 'Demande d\'assistance',
        // icon: 'faUsersGear',
        icon: 'fa-solid fa-comments',
        children: ['nouveau', 'liste']
    },
    // {
    //     url: 'infos',
    //     name: 'Infos utiles',
    //     icon: 'fa-file-contract'
    // },
    // ,  {
    //     url: 'suivi-client',
    //     name: 'Suivi Client',
    //     icon: 'fa-solid fa-headphones-simple'
    // },
    // {
    //     url: 'jerico',
    //     name: 'Back Office Jerico',
    //     icon: 'fa-solid fa-gears'
    // },
    {
        url: 'formation_jerico',
        name: 'Tutoriel Jerico',
        icon: 'fa-solid fa-gear',
        externalUrl: 'https://wiki.meosis.fr/'
    },
    {
        url: 'faq',
        name: 'FAQ',
        icon: 'fa-solid fa-question',
        externalUrl: 'https://www.meosis.fr/faq.html'
    },
]

export const MenuItem = ({ url, icon, name, externalUrl }) => {

    // Détecter la couleur de fond de l'item en fonction du nom 
    let bgColorClass = '';

    if (name.toLowerCase().includes("faq")) {
        bgColorClass = 'bg-custom-blue'; // Fond bleu foncé pour "FAQ"
    } else {
        bgColorClass = 'bg-custom-green'; // Fond vert pour les autres liens
    }

    // // Modifier dynamiquement l'URL externe de "Formation Jerico"
    // const [dynamicExternalUrl, setDynamicExternalUrl] = useState(externalUrl);

    // useEffect(() => {
    //     if (name === "Tutoriel Jerico") {
    //         // Récupérer l'objet utilisateur complet depuis le localStorage
    //         const userData = JSON.parse(localStorage.getItem('user'));

    //         if (userData && userData.type_site) {
    //             const typeSite = userData.type_site;  // Récupérer type_site

    //             if (typeSite === 'vitrine') {
    //                 setDynamicExternalUrl('https://cdn.cluster014.hosting.meosis.fr/pdf/formation-meosis/guide-jerico.pdf');
    //             } else if (typeSite === 'ecommerce') {
    //                 setDynamicExternalUrl('https://www.meosis.fr/wp-content/uploads/2024/09/Formation-Jerico-E-Commerce.pdf');
    //             } else {
    //                 setDynamicExternalUrl('https://cdn.cluster014.hosting.meosis.fr/pdf/formation-meosis/guide-jerico.pdf');
    //             }
    //         } else {
    //             setDynamicExternalUrl('https://cdn.cluster014.hosting.meosis.fr/pdf/formation-meosis/guide-jerico.pdf');
    //         }
    //     }
    // }, [name]);  // La logique se déclenche uniquement si le nom est "Formation Jerico"


    // // Lien dynamique pour "Formation Jerico"
    // if (dynamicExternalUrl) {
    //     return (
    //         <a
    //             href={dynamicExternalUrl}
    //             target="_blank"
    //             rel="noopener noreferrer"
    //             className={`flex flex-col sm:flex-row items-center justify-center sm:justify-start p-x2 p-4 md:pl-6 leading-tight rounded-3xl shadow-[0_2px_10px_rgba(0,0,0,0.2)] hover:shadow-[0_3px_15px_rgba(0,0,0,0.25)] duration-200 will-change-transform text-center h-full ${bgColorClass} hover:translate-y-[-5px]`}
    //         >
    //             <div className="flex items-center justify-center bg-white rounded-full w-8 h-8 p-2">
    //                 <FontAwesomeIcon className="w-4 h-4" icon={icon} />
    //             </div>
    //             <span className="block m-3 uppercase font-bold lg:block text-lg text-white text-center xl:text-start">
    //                 {name}
    //             </span>
    //         </a>
    //     );
    // }

    // Lien en dure 
    if (externalUrl) {
        return (
            <a
                href={externalUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={` flex flex-col sm:flex-row items-center justify-center sm:justify-start p-x2 p-4 lg:p-6 md:pl-6 leading-tight rounded-3xl shadow-[0_2px_10px_rgba(0,0,0,0.2)] hover:shadow-[0_3px_15px_rgba(0,0,0,0.25)] duration-200 will-change-transform text-center h-full ${bgColorClass} hover:translate-y-[-2px]`}
            >
                <div className="flex items-center justify-center bg-white rounded-full w-8 h-8 p-2 md:mr-4">
                    <FontAwesomeIcon className="w-4 h-4" icon={icon} />
                </div>
                <span className="block text-sm md:text-lg leading-normal sm:text-left uppercase font-bold lg:block text-white pt-1">
                    {name}
                </span>
            </a>
        );
    }

    return (
        <NavLink
            to={"/" + url}
            className={({ isActive, isPending }) =>
                `flex flex-col sm:flex-row items-center justify-center sm:justify-start p-x2 p-4 lg:p-6 md:pl-6 leading-tight rounded-3xl shadow-[0_2px_10px_rgba(0,0,0,0.2)] hover:shadow-[0_3px_15px_rgba(0,0,0,0.25)] transition-transform duration-200 will-change-transform h-full ${isActive ? "text-indigo-600" : ""
                } ${isPending ? "text-cyan-600" : ""} hover:translate-y-[-2px]`
            }
        >
            <div className="flex items-center justify-center bg-custom-green rounded-full w-8 h-8 p-2 md:mr-4">
                <FontAwesomeIcon className="text-white w-4 h-4" icon={icon} />
            </div>

            <span className="text-center text-sm md:text-lg leading-normal sm:text-left block uppercase font-bold lg:block pt-1">
                {name}
            </span>
        </NavLink>
    )
}

export const MenuDashboard = () => {
    let cols = 2
    switch (menu_items.length) {
        case 8:
            cols = 2;
            break;

        default:
            cols = Math.ceil(menu_items.length / 2)
            break;
    }

    return (
        <>
            <div className="flex justify-center">
                <ul className={`grid grid-cols-2 auto-rows-fr md:grid-cols-2 lg:grid-cols-${cols} gap-4 lg:gap-8 w-full`}>
                    {menu_items.map((el, index) => (
                        <li key={index} className="lg:text-xl custom-color">
                            <MenuItem
                                url={el.url}
                                name={el.name}
                                icon={el.icon}
                                externalUrl={el.externalUrl} // Passe l'URL externe si présente
                            />
                        </li>
                    ))}
                </ul>
            </div>
        </>
    )
}

export const Menu = ({ isOpen, openMenu, closeMenu }) => {

  const { logout } = useAuth();
  const [user, setUser] = useLocalStorage("user", null);
  const menuNav = useRef(null);
  const [dynamicExternalUrl, setDynamicExternalUrl] = useState(null);

  const location = useLocation();
  const isHomePage = location.pathname === '/dashboard';

  // Gère l'URL dynamique pour Jerico
  useEffect(() => {
    if (user && user.type_site) {
      const typeSite = user.type_site;
      if (typeSite === 'vitrine') {
        setDynamicExternalUrl('https://cdn.cluster014.hosting.meosis.fr/pdf/formation-meosis/guide-jerico.pdf');
      } else if (typeSite === 'ecommerce') {
        setDynamicExternalUrl('https://www.meosis.fr/wp-content/uploads/2024/09/Formation-Jerico-E-Commerce.pdf');
      } else {
        setDynamicExternalUrl('https://cdn.cluster014.hosting.meosis.fr/pdf/formation-meosis/guide-jerico.pdf');
      }
    }
  }, [user]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuNav.current && !menuNav.current.contains(event.target)) {
        closeMenu();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, closeMenu]);

  return (
    <>
      <div className="menu-wrapper">
        <div className={`overlay bg-gray-500/25 fixed transition-all inset-0 z-[1002] ${isOpen ? 'visible opacity-100' : 'invisible opacity-0'}`}></div>
        <nav className={`bg-mdark fixed top-0 right-0 bottom-0 z-[1003] transition-all flex flex-col ${isOpen ? 'translate-x-0' : 'translate-x-full'}`} ref={menuNav}>
          <div className="font-bold text-xl pl-10 pr-3 pb-3 flex justify-between mt-6">
            {user && user.contact ? user.contact.prenom + ' ' + user.contact.nom : 'Bonjour'}
            <button className="text-xl px-2 py-1" onClick={closeMenu}>
              <FontAwesomeIcon icon="fa-solid fa-xmark" />
            </button>
          </div>
          <ul>
            {menu_items.map((el, index) => (
              <li key={index}>
                {el.externalUrl ? (
                  <a href={el.externalUrl} target="_blank" rel="noopener noreferrer" className="flex items-center p-5">
                    <span className="mx-5 w-6 text-center">
                      <FontAwesomeIcon className="text-mgray opacity-35" icon={el.icon} />
                    </span>
                    <span className="block grow w-full font-bold">
                      {el.name}
                    </span>
                  </a>
                ) : (
                  el.url === "formation_jerico" && dynamicExternalUrl ? (
                    <a href={dynamicExternalUrl} target="_blank" rel="noopener noreferrer" className="flex items-center p-5">
                      <span className="mx-5 w-6 text-center">
                        <FontAwesomeIcon className="text-mgray opacity-35" icon={el.icon} />
                      </span>
                      <span className="block grow w-full font-bold">
                        {el.name}
                      </span>
                    </a>
                  ) : (
                    <NavLink to={"/" + el.url} className={({ isActive, isPending }) =>
                      `flex items-center p-5 ${isActive ? "text-mlime" : isPending ? "text-cyan-600" : ""}`
                    }>
                      {({ isActive, isPending }) => (
                        <>
                          <span className="mx-5 w-6 text-center">
                            <FontAwesomeIcon className={`text-mgray opacity-35 ${isActive ? "text-mlime" : isPending ? "text-cyan-600" : ""}`} icon={el.icon} />
                          </span>
                          <span className="block grow w-full font-bold">
                            {el.name}
                          </span>
                        </>
                      )}
                    </NavLink>
                  )
                )}
              </li>
            ))}
          </ul>
          <button className="bg-morange hover:bg-morange-600 focus:outline-none text-white font-bold py-5 px-4 absolute bottom-0 left-0 right-0 w-full" onClick={logout}>
            <FontAwesomeIcon className="mr-3" icon="fa-solid fa-arrow-right-from-bracket" />
            Déconnexion
          </button>
        </nav>
      </div>
    </>
  );
};
